var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"list-disc pl-5 space-y-1"},_vm._l((_vm.items),function(item,index){return _c('li',{key:index,staticClass:"text-sm text-gray-700"},[(typeof item === 'object' && item !== null)?[_c('RichObjectDisplay',{attrs:{"data":item}})]:[_vm._v(" "+_vm._s(item)+" ")]],2)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }